export default "__VITE_ASSET__KkQa$RkH__"